/**
 * Registers `public/sw.js`, which answers a repeat visit's content-hashed assets from a cache
 * instead of revalidating each one against the server (FR-015-120; the worker's own comment
 * carries what it caches and why a stale bundle cannot come out of it).
 *
 * After the load event, for the same reason the speculative chunk prefetch waits for it
 * (`app/prefetch.ts`): the registration's own request and the worker's install compete with the
 * chunks the first screen is waiting for. Both documents register it, because the sign-in card's
 * assets are worth a cache too and the scope is the whole origin either way.
 *
 * A browser with no service worker support, a document that is not a secure context, and a
 * registration the browser refuses all leave the client working exactly as it does without one,
 * so a failure is not raised: there is nothing for a person to do about it.
 */
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  const register = () => {
    void navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  };
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
}
